import styled from '@emotion/styled';
import * as React from 'react';
import { PHONE_MEDIA } from '../vars';

export interface FAQProps {
  question: string;
  children?: React.ReactNode;
}

export const FAQ: React.FC<FAQProps> = ({ question, children }) => {
  return (
    <S.FAQPair>
      <S.FAQQuestion>
        <S.FAQHeading>{question}</S.FAQHeading>
        <S.FAQQuestionLabel>Question</S.FAQQuestionLabel>
      </S.FAQQuestion>
      <S.FAQAnswer>
        <S.FAQAnswerLabel>Answer</S.FAQAnswerLabel>
        <S.FAQAnswerContent>{children}</S.FAQAnswerContent>
      </S.FAQAnswer>
    </S.FAQPair>
  );
};

namespace S {
  export const FAQPair = styled.div`
    margin-top: 30px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 22px 24px 24px;
    border-radius: 18px;
    border: 1px solid ${(p) => p.theme.text.listBorder};
    background: ${(p) => p.theme.card.background};
    box-shadow: ${(p) => p.theme.card.shadow};
    overflow: hidden;

    @media (max-width: ${PHONE_MEDIA}px) {
      padding: 18px 18px 20px;
    }
  `;

  export const FAQQuestion = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
  `;

  const FAQLabel = styled.div`
    display: inline-flex;
    align-items: center;
    margin-bottom: 10px;
    font-size: 11px;
    line-height: 1;
    font-weight: 700;
    letter-spacing: 0.18em;
    text-transform: uppercase;

    @media (max-width: ${PHONE_MEDIA}px) {
      margin-bottom: 8px;
    }
  `;

  export const FAQQuestionLabel = styled(FAQLabel)`
    flex-shrink: 0;
    margin: 6px 0 0;
    color: ${(p) => p.theme.text.special};
    padding: 6px 10px;
    border-radius: 999px;
    border: 1px solid ${(p) => p.theme.text.listBorder};
    background: ${(p) => p.theme.text.listBackground};
  `;

  export const FAQHeading = styled.h3`
    margin-top: 0;
    color: ${(p) => p.theme.text.heading};
    font-size: 28px;
    line-height: 1.25;

    @media (max-width: ${PHONE_MEDIA}px) {
      font-size: 24px;
      text-align: left;
    }
  `;

  export const FAQAnswer = styled.div`
    padding-top: 16px;
    border-top: 1px solid ${(p) => p.theme.text.listBorder};

    @media (max-width: ${PHONE_MEDIA}px) {
      padding-top: 14px;
    }
  `;

  export const FAQAnswerLabel = styled(FAQLabel)`
    color: ${(p) => p.theme.text.paragraph};
    opacity: 0.9;
  `;

  export const FAQAnswerContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 18px;

    > p {
      font-size: 15px;
      line-height: 1.8;
    }
  `;
}
